import { EMAIL_CODES } from './emailCodes'
import { SMS_CODES } from './smsCodes'

export const MESSAGE_EVENTS = {
  [EMAIL_CODES.E003]: 'Initial Leak Free',
  [EMAIL_CODES.E004]: 'Low-flow Leak Alert',
  [EMAIL_CODES.E005]: 'Leak Fixed',
  [EMAIL_CODES.E006]: 'Installed on Pipe',
  [EMAIL_CODES.E007]: 'No Signal',
  [EMAIL_CODES.E008]: 'High Usage',
  [EMAIL_CODES.E009]: 'Low Signal',
  [EMAIL_CODES.E010]: 'Locked Account',
  [EMAIL_CODES.E011]: 'Password Reset',
  [EMAIL_CODES.E012]: 'Customer Survey',
  [EMAIL_CODES.E013]: 'Eng Repaired Leak',
  [EMAIL_CODES.E014]: 'Verify Email',
  [EMAIL_CODES.E017]: 'Lost Wifi Connection',
  [EMAIL_CODES.E030]: 'Analysing Mode Enabled',
  [EMAIL_CODES.E031]: 'Analysing Mode Disabled',
  [EMAIL_CODES.E034]: 'Device reconnected',
  [EMAIL_CODES.E045]: 'Lost connection reminder',
  [EMAIL_CODES.E047]: 'First Leak Reminder',
  [EMAIL_CODES.E048]: 'Intermediate Leak Reminder',
  [EMAIL_CODES.E049]: 'Final Leak Reminder',
  [EMAIL_CODES.E050]: 'Low Battery',
  [EMAIL_CODES.E055]: 'ON PIPE Reminder',
  [EMAIL_CODES.E032]: 'Frozen Pipe Warning',
  [EMAIL_CODES.E039]: 'First Install Chaser',
  [EMAIL_CODES.E040]: 'Intermediate Install Chaser',
  [EMAIL_CODES.E041]: 'Final Install Chaser',
  [SMS_CODES.C032]: 'Frozen Pipe Warning',
  [SMS_CODES.C039]: 'Install Chaser 1',
  [SMS_CODES.C040]: 'Install Chaser 2',
  [SMS_CODES.C041]: 'Install Chaser 3',
  [SMS_CODES.C045]: 'Lost Connection Reminder',
  [SMS_CODES.C037]: 'Edit Engineer Booking',
  [SMS_CODES.C038]: 'Cancel Engineer Booking',
  [SMS_CODES.C003]: 'Initial Leak Free',
  [SMS_CODES.C004]: 'Low-flow Leak Alert',
  [SMS_CODES.C005]: 'Leak Fixed',
  [SMS_CODES.C006]: 'Installed on Pipe',
  [SMS_CODES.C008]: 'High Usage',
  [SMS_CODES.C013]: 'Eng Repaired Leak',
  [SMS_CODES.C017]: 'Lost Wifi Connection',
  [SMS_CODES.C021]: 'Eng Visit Booking Confirmation',
  [SMS_CODES.C024]: 'Low-flow Leak Alert Reminder',
  [SMS_CODES.C025]: 'Job Booking reminder',
  [SMS_CODES.C047]: 'First Leak Reminder',
  [SMS_CODES.C048]: 'Intermediate Leak Reminder',
  [SMS_CODES.C049]: 'Final Leak Reminder',
  [SMS_CODES.C050]: 'Low Battery',
}
